import { render, staticRenderFns } from "./SpecificationsInfo.vue?vue&type=template&id=6765b2ff&scoped=true&"
import script from "./SpecificationsInfo.vue?vue&type=script&lang=js&"
export * from "./SpecificationsInfo.vue?vue&type=script&lang=js&"
import style0 from "./SpecificationsInfo.vue?vue&type=style&index=0&id=6765b2ff&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6765b2ff",
  null
  
)

export default component.exports